import Card from "common/Boxes/Card";
import Title from "common/Typography/Title";
import Link from "common/Typography/Link";
import Flex from "common/Boxes/Flex";
import { CSSProperties, FC, PropsWithChildren } from "react";
import useOverview from "features/affiliation/common/hooks/useOverview";
import { AffiliationTabs } from "features/affiliation/common/types";
import useMedia from "utils/hooks/useMedia";
import { TABLET } from "common/constants";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

interface CardWithTitleProps {
  title?: string;
  relatedTab?: AffiliationTabs;
  cardStyle?: CSSProperties;
  titleStyle?: CSSProperties;
}

const CardWithTitle: FC<PropsWithChildren<CardWithTitleProps>> = ({
  title,
  relatedTab,
  cardStyle,
  titleStyle,
  children,
}) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);
  const { onSeeAllClick } = useOverview();
  const isTablet = useMedia([`(max-width: ${TABLET})`], [true], false);

  return (
    <Card style={{ padding: isTablet ? 12 : 16, height: "100%", ...cardStyle }}>
      {title && (
        <Flex style={{ marginBottom: 16, ...titleStyle }}>
          <Title level={3} type="secondary">
            {title}
          </Title>
          {relatedTab && (
            <Link onClick={() => onSeeAllClick(relatedTab)}>
              {t("common.see_all")}
            </Link>
          )}
        </Flex>
      )}
      {children}
    </Card>
  );
};

export default CardWithTitle;
